import { GridController, gridTpl } from '../../../../common/grid/grid.controller';

/**
 * Creates a new AdministrationAccountsContactLocationsGridController.
 * @class
 * @memberOf module:root/legacy/components/administration
 */
class AdministrationAccountsContactLocationsGridController extends GridController {
    /**
     * @constructor
     * @param $ngRedux {service} {@link https://github.com/angular-redux/ng-redux|ng-redux}
     * @param $state {service} {@link https://ui-router.github.io/ng1/docs/latest/classes/state.stateservice.html|UI-Router StateService}
     * @param NavigationService {service} {@link module:root/common.NavigationService|NavigationService}
     * @param $filter {service}
     * @param EmployeesActions {service}
     */
    constructor($ngRedux, $state, NavigationService, $filter, EmployeesActions) {
        super($ngRedux, $state, NavigationService, $filter);
        this.$ngRedux = $ngRedux;
        this.actions = EmployeesActions;
    }

    /**
     * @method $onInit
     * @memberof module:root/legacy/components/administration.AdministrationAccountsContactLocationsGridController
     * @description Component lifecycle hook
     * @see {@link https://docs.angularjs.org/guide/component#component-based-application-architecture|AngularJS component lifecycle hook $onInit}
     */
    $onInit() {
        this.module = 'administration';
        this.filterComponent = false;
        this.exportComponent = false;

        this.columns = [
            {title: '#',        mapper: null},
            {title: this.$filter('translate')('EMPLOYEES.LOCATIONS.GRID_LOCATION_NAME'), mapper: 'name'},
            {title: 'Parent name', mapper: 'parentUsername'},
            {title: 'Status', mapper: 'status'},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), this.actions)(this);
        this.dataAction = this.getEmployeeLocations;
        this.filter.identifier = this.identifier;
        this.filter.uuid = this.uuid;

        this.init();
    }
}

AdministrationAccountsContactLocationsGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', 'EmployeesActions'];

export const administrationAccountsContactLocationsGrid = {
    bindings: {
        identifier: '@',
        uuid: '<',
        onRemove: '&'
    },
    controller: AdministrationAccountsContactLocationsGridController,
    ...gridTpl
};
